import { HttpClient, HttpResponse } from '@angular/common/http';
import { Component, inject } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ModalService } from '../../../shared/services/modal/modal.service';
import { AdminGuardStateService } from '../../services/admin-guard-state/admin-guard-state.service';
import { userStore } from '../../user.store';

@Component({
  selector: 'app-admin-guard',
  templateUrl: './admin-guard.component.html',
  styleUrls: ['./admin-guard.component.scss'],
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule],
})
export class AdminGuardComponent {
  private router = inject(Router);
  private readonly modalService = inject(ModalService);
  private http = inject(HttpClient);
  readonly store = inject(userStore);
  readonly adminGuardState = inject(AdminGuardStateService);

  verfifPasswordControl: FormControl<string> = new FormControl<string>('', { nonNullable: true, validators: [Validators.required] });

  get isAdmin(): boolean {
    return this.adminGuardState.adminCheck();
  }

  get isAuthorized(): boolean {
    return this.adminGuardState.authorized();
  }

  constructor() {}

  cancel(): void {
    this.verfifPasswordControl.reset();
    this.adminGuardState.adminCheck.set(false);
    window.history.back();
  }

  verify(): void {
    if (this.verfifPasswordControl.invalid) {
      return;
    }
    const url = decodeURIComponent(window.location.pathname.split('/')[2]);
    const path = window.atob(url);

    const allQueryParams = decodeURIComponent(window.location.pathname.split('/')[3]);
    let queryParamsObject: { [key: string]: any } = {};

    if (allQueryParams != 'undefined') {
      const allQueryParamsDocoded = window.atob(allQueryParams).split('&');
      let listKeyValueQueryParams = [];
      for (let i = 0; i < allQueryParamsDocoded.length; i++) {
        listKeyValueQueryParams.push(allQueryParamsDocoded[i].split('='));
      }
      listKeyValueQueryParams.forEach((pair) => {
        let key = pair[0];
        let value = pair[1];
        queryParamsObject[key] = value;
      });
    }

    const queryParamsFormatted = {
      queryParams: queryParamsObject,
    };

    this.verificationQuery(this.verfifPasswordControl.value, path).subscribe({
      next: (response) => {
        this.verfifPasswordControl.reset();
        if (response.status === 200) {
          this.adminGuardState.authorized.set(false);
          this.adminGuardState.adminCheck.set(false);
          this.router.navigate([path], queryParamsFormatted);
        } else {
          this.modalService.openAlert('error', 'Erreur', 'Mauvais mot de passe !', () => {
            this.modalService.closeAlert();
          });
          throw new Error('Mauvais mot de passe !');
        }
      },
      error: () => {
        this.modalService.openAlert('error', 'Erreur', 'Mauvais mot de passe !', () => {
          this.modalService.closeAlert();
        });
        throw new Error('Mauvais mot de passe !');
      },
      complete: () => {
        this.verfifPasswordControl.reset();
      },
    });
  }

  verificationQuery(password: string, link: string): Observable<HttpResponse<string>> {
    return this.http.post<string>(`${environment.apiUrl}/auth/password-verify`, { mail: this.store.user().mail, password }, { observe: 'response' });
  }
}
